
import React, { createContext, useContext, ReactNode } from 'react';
import { usePersona, Persona } from '@/hooks/usePersona';
import { useNavigate } from 'react-router-dom';
import { toast } from '@/components/ui/use-toast';

interface PersonaContextType {
  personas: Persona[];
  currentPersona: Persona | null;
  switchPersona: (persona: Persona) => void;
  isLoading: boolean;
}

const PersonaContext = createContext<PersonaContextType | undefined>(undefined);

export const PersonaProvider = ({ children }: { children: ReactNode }) => {
  const { personas, currentPersona, switchPersona, isLoading } = usePersona();
  const navigate = useNavigate();

  const handleSwitchPersona = (persona: Persona) => {
    switchPersona(persona);
    navigate(persona.default_path);
    toast({
      title: "Persona Changed",
      description: `Switched to ${persona.name} view`,
    });
  };

  return (
    <PersonaContext.Provider
      value={{
        personas,
        currentPersona,
        switchPersona: handleSwitchPersona,
        isLoading
      }}
    >
      {children}
    </PersonaContext.Provider>
  );
};

export const usePersonaContext = () => {
  const context = useContext(PersonaContext);
  if (context === undefined) {
    throw new Error('usePersonaContext must be used within a PersonaProvider');
  }
  return context;
};
